/* tslint:disable */

/**
 */
export class RecordPosition {
    AVERAGE_ENTH_VAR?: number;
    AVERAGE_TEMP?: number;
    ENTHALPY_VAR?: number;
    ID_REC_POS?: number;
    ID_STUDY_EQUIPMENTS?: number;
    RECORD_BUFFER?: number;
    RECORD_STATE?: number;
    RECORD_TIME?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/record-position.ts